import tracing from "./tracing/module";
import routing from "./routing/module";
import analytics from "./analytics/module";
import logging from "./logging/module";

export default angular.module("core", [tracing, routing, analytics, logging]).name;
